module.exports = __webpack_public_path__ + "media/images/icons/material/calendar-outline-0e4ed2e8b59324b4d270918a51338bc1.svg";